export default "__VITE_ASSET__d1268af4__"